/*
 * Mobiel menu in lagen.
 *
 * Elk niveau is een paneel dat inschuift. Een rij met chevron opent een paneel,
 * een rij zonder chevron navigeert. De terugknop gaat één niveau terug.
 *
 * Panelen heten p1, p1-r2 enzovoort. De ouder is het stuk voor de laatste
 * streep; is die er niet, dan is de ouder niveau 1.
 */
class ArchiefMobileMenu extends HTMLElement {
  connectedCallback() {
    this.root = this.querySelector("[data-amm-root]");
    this.back = this.querySelector("[data-amm-back]");
    /* Niet this.title: dat is de ingebouwde tooltip-eigenschap van elk
       HTML-element, die een toegewezen element stilletjes naar tekst omzet. */
    this.titleEl = this.querySelector("[data-amm-title]");
    this.panels = new Map();
    this.querySelectorAll("[data-amm-panel]").forEach((p) => {
      this.panels.set(p.dataset.ammPanel, p);
    });
    this.stack = [];

    this.addEventListener("click", (event) => {
      const opener = event.target.closest("[data-amm-open]");
      if (opener && this.contains(opener)) {
        event.preventDefault();
        this.go(opener.dataset.ammOpen, opener);
        return;
      }
      if (event.target.closest("[data-amm-back]")) {
        event.preventDefault();
        this.goBack();
      }
    });

    /* Menu dicht en weer open: begin opnieuw op niveau 1. */
    this.modal = this.closest("modal-dialog");
    if (this.modal) {
      this.modal.addEventListener("on:modal:closed", () => this.reset());
    }
    this.update();
  }

  go(id, trigger) {
    const panel = this.panels.get(id);
    if (!panel) return;
    this.currentEl().hidden = true;
    panel.hidden = false;
    this.animate(panel, "vooruit");
    this.stack.push({ id, trigger: trigger || null });
    this.update();
    this.scrollTop();
    if (this.back) this.back.focus({ preventScroll: true });
  }

  goBack(animate = true) {
    const vorige = this.stack.pop();
    if (vorige) this.panels.get(vorige.id).hidden = true;
    const el = this.currentEl();
    el.hidden = false;
    if (animate) this.animate(el, "terug");
    this.update();
    this.scrollTop();
    if (animate && vorige && vorige.trigger) vorige.trigger.focus({ preventScroll: true });
  }

  currentEl() {
    const huidig = this.stack[this.stack.length - 1];
    return huidig ? this.panels.get(huidig.id) : this.root;
  }

  /* De richting van de beweging vertelt of je dieper gaat of terugkeert. */
  animate(el, richting) {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    el.classList.remove("amm-vooruit", "amm-terug");
    /* Reflow, anders start de animatie niet opnieuw. */
    void el.offsetWidth;
    el.classList.add(richting === "terug" ? "amm-terug" : "amm-vooruit");
  }

  /* Op niveau 1 staat "Menu" in de balk; dieper de paneeltitel, die naar de
     bijbehorende pagina linkt als die er is. */
  update() {
    const huidig = this.stack[this.stack.length - 1];
    const panel = huidig ? this.panels.get(huidig.id) : null;
    this.classList.toggle("is-deep", Boolean(panel));
    if (this.back) this.back.hidden = !panel;
    if (!this.titleEl) return;

    this.titleEl.hidden = false;
    this.titleEl.textContent = panel ? panel.dataset.title || "" : "Menu";
    if (panel && panel.dataset.url) {
      this.titleEl.href = panel.dataset.url;
    } else {
      this.titleEl.removeAttribute("href");
    }
  }

  scrollTop() {
    const scroller = this.closest(".modal__content");
    if (scroller) scroller.scrollTop = 0;
  }

  reset() {
    while (this.stack.length) this.goBack(false);
  }
}

if (!customElements.get("archief-mobile-menu")) {
  customElements.define("archief-mobile-menu", ArchiefMobileMenu);
}
